export const GET_LOGS = "GET_LOGS";
export const ADD_LOG = "ADD_LOG";
export const DELETE_LOG = "DELETE_LOG";
export const UPDATE_LOG = "UPDATE_LOG";
export const LOGS_ERROR = "LOGS_ERROR";
export const SEARCH_LOGS = "SEARCH_LOGS";
//setting and clearing current value in the form
export const SET_CURRENT = "SET_CURRENT";
export const CLEAR_CURRENT = "CLEAR_CURRENT";

export const CLEAR_LOGS = "CLEAR_LOGS";
export const SET_LOADING = "SET_LOADING";

export const GET_TECHS = "GET_TECHS";
export const ADD_TECH = "ADD_TECH";
export const DELETE_TECH = "DELETE_TECH";
export const TECHS_ERROR = "TECHS_ERROR";
